module.exports = __webpack_public_path__ + "img/logo.a293f0f3.svg";